import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@mui/material/IconButton";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import StudentCardProgress from "../../Components/ProgressBar/StudentCardProgress";
import CardMedia from "@mui/material/CardMedia";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

const StudentRewardCard = (props) => {
  const classes = useStyles();
  const loadImage = () => {
    switch (props.image) {
      case "like":
        return require('../../assets/thumbbadgh.png');
    }
  };

  return (
    <>
      
      <Card
        className={classes.card1}
        sx={{ boxShadow: "none", position: "relative" }}
      >
        <CardMedia sx={{ textAlign: "center" }} title="green iguana">
          <img src={loadImage()} className={classes.image}></img>
        </CardMedia>
        <CardContent sx={{ py: 1 }}>
          <Typography
            className={classes.ModuleNum}
            sx={{ color: "primary.main", lineHeight: 1 }}
          >
            {props.title ? props.title : ""}
          </Typography>
          <Typography
            className={classes.ModuleName}
            sx={{ color: "primary.main" }}
          >
            {props.description ? props.description : ""}
          </Typography>
        </CardContent>
        {props.action && (
          <CardActions sx={{ justifyContent: "flex-end", py: 0, pb: 1, pt: 1 }}>
            <IconButton
              aria-label="Go"
              size="small"
              sx={{
                position: "absolute",
                bottom: 10,
                right: 10,
                borderRadius: "50%",
                backgroundColor: "primary.main",
                color: "#FFF",
                padding: 0.5,
                "@media (min-width: 1636px)": {
                  mt: 2,
                },
               
              }}
            >
              <PlayArrowOutlinedIcon
                fontSize="inherit"
                sx={{
                  fontSize: "1rem",
                  "@media (min-width: 1636px)": {
                    fontSize: "2rem",
                  },
                }}
              />
            </IconButton>
          </CardActions>
        )}
      </Card>
      
    </>
  );
};

const useStyles = makeStyles({
  card: {
   background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%)",
    width: "11rem",
    height: "14rem",
    borderRadius: 17,
    shadowColor: "#000",
    boxShadow: "2rem",
    paddingTop: "1rem",
    "@media (min-width: 1636px)": {
      width: "20rem",
      height: "25rem",
    },
  },
  card1: {
   background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%)",
    width: "11rem",
    height: "14rem",
    borderRadius: 17,
    shadowColor: "#000",
    boxShadow: "2rem",
    paddingTop: "1rem",
    "@media (min-width: 1636px)": {
      width: "20rem",
      height: "25rem",
    },
  },
  ModuleNum: {
    fontSize: "1.1rem",
    textAlign: "center",
    fontWeight: "900",
    "@media (min-width: 1636px)": {
      fontSize: "1.8rem",
    },
  },
  ModuleName: {
    fontSize: "0.8rem",
    textAlign: "center",
    fontWeight: "500",
    paddingTop: 5,
    "@media (min-width: 1636px)": {
      fontSize: "1.2rem",
    },
  },
  image: {
    width: "5rem",
    "@media (min-width: 1636px)": {
      width: "12rem",
    },
  },
});

export default StudentRewardCard;
